import { buildWhatsAppUrl } from '../lib/whatsapp';

/** Teléfono clicable que abre chat de WhatsApp. */
export default function WhatsAppLink({ phone, className, children, ...rest }) {
  const display = children ?? phone;
  if (!String(phone || '').trim()) return null;

  return (
    <a
      href={buildWhatsAppUrl(phone)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      {...rest}
    >
      {display}
    </a>
  );
}
